export function isTestAccount(email) {
  if (Boolean(email) && typeof email === 'string') {
    const username = email.split('@')[0].toLowerCase()
    const isLexstepTestAccount =
      email.toLowerCase().endsWith('@lexstep.com') &&
      username.contains('+') &&
      username.contains('test')

    const isEmumba = email.toLowerCase().endsWith('@emumba.com')

    if (isLexstepTestAccount || isEmumba) return true
    return false
  }

  return true
}



// WEBPACK FOOTER //
// ./scripts/shared/services/is-test-account.js